module.exports = __webpack_public_path__ + "img/suite.c68562b9.svg";